import "./i18n-syncfusion"; // carregando translate portugues e espanhol do syncfusion
import "./i18n/index.jsx"; // carregando translate portugues e espanhol do sistema inteiro
import "./Services/posthog";

import React, { useEffect } from "react";
import Routing from "./Routes/Routing";

// Store and providers
import { Provider } from "react-redux";
import { MapProvider } from "./contexts/ClustererContext";
import { FleetViewProvider } from "./contexts/FleetViewContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import store from "./Redux/store";

import TitleUpdater from "./TitleUpdater";
import FaviconUpdater from "./FaviconUpdater";
import { registerLicense } from "@syncfusion/ej2-base";
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

// Styles
import { SelectedProvider } from "./contexts/SelectedContext";
import { PermissionsProvider } from "./contexts/PermissionsContext";
import "./styles/themes.css";
import { NewThemeProvider } from "./contexts/NewThemeContext";


async function registerFirebase() {
  try {
    const supported = await isSupported();

    if (!supported) {
      console.log("Firebase Messaging não é suportado neste navegador.");
      return;
    }

    if (typeof window === "undefined" || !("Notification" in window)) {
      console.log("API de Notification não suportada.");
      return;
    }

    const app = initializeApp({
      apiKey: "AIzaSyBGr3Nva_5ILXjWopLjd_K7VmcVA8o6FPU",
      authDomain: "movyx-maps.firebaseapp.com",
      projectId: "movyx-maps",
      storageBucket: "movyx-maps.firebasestorage.app",
      messagingSenderId: "859852506246",
      appId: "1:859852506246:web:6e77f461366d479e3b3d07",
      measurementId: "G-Z0J2289W35",
    });

    const messaging = getMessaging(app);

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Permissão para notificações não concedida.");
      return;
    }

    console.log("Notification permission granted.");

    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FCM_VAPID_KEY,
    });

    if (currentToken) {
      console.log("Current token for client:", currentToken);
    } else {
      console.log("Nenhum token FCM foi gerado.");
    }

    onMessage(messaging, (payload) => {
      console.log("Message received:", payload);

      const title = payload?.notification?.title || "Notificação";
      const body = payload?.notification?.body || "";

      alert(`${title} ${body}`);
    });
  } catch (error) {
    console.error("Erro ao inicializar Firebase Messaging:", error);
  }
}

function App() {
  useEffect(() => {
    if (process.env.REACT_APP_SYNCFUSION_SECRET) {
      registerLicense(process.env.REACT_APP_SYNCFUSION_SECRET);
    }
    registerFirebase();
  }, []);

  return (
    <React.Fragment>
      <Provider store={store}>
        <ThemeProvider>
          <NewThemeProvider>
            <TitleUpdater />
            <FaviconUpdater />
            <PermissionsProvider>
              <SelectedProvider>
                <MapProvider>
                  <FleetViewProvider>
                    <Routing />
                  </FleetViewProvider>
                </MapProvider>
              </SelectedProvider>
            </PermissionsProvider>
          </NewThemeProvider>
        </ThemeProvider>
      </Provider>
    </React.Fragment>
  );
}

export default App;
